module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('smallBar', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-info",
    staticStyle: {
      "padding": "5px 60px"
    },
    on: {
      "click": function($event) {
        _vm.AddStageModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增階段")])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("可在此區自訂所有交易的階段，也可拖曳改變順序，或是新增您所需要的階段")]), _vm._v(" "), _c('div', {
    staticClass: "widget-content"
  }, [_c('div', [_c('draggable', {
    staticClass: "list-group setting-ul",
    attrs: {
      "element": "ul",
      "options": _vm.dragOptions
    },
    on: {
      "change": function($event) {
        _vm.onChange()
      }
    },
    model: {
      value: (_vm.stages),
      callback: function($$v) {
        _vm.stages = $$v
      },
      expression: "stages"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition"
    }
  }, _vm._l((_vm.stages), function(stage) {
    return _c('li', {
      key: stage.stage_no,
      staticClass: "list-group-item stage_box",
      style: (_vm.stage_width),
      on: {
        "click": function($event) {
          _vm.EditStage(stage)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pen"
    }), _vm._v(" 階段" + _vm._s(stage.stage_no + 1)), _c('br'), _vm._v("\n                        " + _vm._s(stage.name) + "\n                      ")])
  }))], 1)], 1)])])])])])])]), _vm._v(" "), (_vm.AddStageModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.AddStageModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.AddStageModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n              新增交易階段\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.AddStageModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_stage_name),
      expression: "new_stage_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "name": "new_stage_name",
      "type": "text",
      "placeholder": "階段名稱"
    },
    domProps: {
      "value": (_vm.new_stage_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_stage_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_stage_name')),
      expression: "errors.has('new_stage_name')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_stage_name')),
      expression: "errors.has('new_stage_name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("不可為空值\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n                新增\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.AddStageModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.EditStageModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.EditStageModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.EditStageModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n              修改交易階段\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.EditStageModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_stage_name),
      expression: "new_stage_name"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "階段名稱"
    },
    domProps: {
      "value": (_vm.new_stage_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_stage_name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.UpdateStage
    }
  }, [_vm._v("\n                更新\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.EditStageModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fail",
    on: {
      "click": _vm.DeleteStage
    }
  }, [_vm._v("\n                刪除\n              ")])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('h3', [_vm._v("交易階段")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc0ff708","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/SetStages.vue
// module id = 711
// module chunks = 4